<div class="sticky-action-bar">
  <span class="selection-count">
    {{ selectionCountText }}
  </span>

  <button
    *ngIf="selectionCount >= 2"
    (click)="onClearSelection()"
    class="clear-all"
    [attr.data-cy]="dataCy ? dataCy + '-clear-button' : 'clear-button'"
  >
    {{ 'i18n.common.clearAll' | translate }}
  </button>

  <ion-button
    class="usf-outline-green-button"
    [ngClass]="isPrimaryButtonDisabled ? 'button-disabled' : 'button-enabled'"
    (click)="onPrimaryAction()"
    [disabled]="isPrimaryButtonDisabled"
    [attr.data-cy]="dataCy ? dataCy + '-primary-button' : 'primary-button'"
  >
    {{ primaryButtonText }}
    <ion-icon name="chevron-forward-outline"></ion-icon>
  </ion-button>
</div>
